module.exports = __webpack_public_path__ + "static/img/TACCHELLA.ac33064d.png";